// Chakra imports
import {
    Box,
    Button,
    Flex,
    Grid, Text, useColorModeValue
} from "@chakra-ui/react";
// Custom icons
import React from "react";
import { useTranslation } from 'react-i18next';
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";

export default function Default() {
  const { t } = useTranslation('support');
  // Chakra Color Mode
  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Text
        color={textColor}
        fontWeight="bold"
        fontSize="3xl"
        mb="30px"
        ps="20px"
      >
        {t('support:title')}
      </Text>

      <Grid
        gap="24px"
        mb={{ lg: "26px" }}
      >
        <Card p="16px">
              <CardBody>
                  <Flex direction="column" w="100%">

                      <Flex direction="column" mt="24px" mb="36px" alignSelf="flex-start">
                          <Text fontSize="lg" color={textColor} fontWeight="bold" mb="6px">
                                {t('support:businessProposal.title')}
                          </Text>
                          <Text fontSize="md" fontWeight="medium" color="gray.400">
                              <Text
                                  as="span"
                                  color={"green.400"}
                                  fontWeight="bold"
                              >
                              </Text>{" "}
                              {t('support:businessProposal.description')}
                          </Text>
                          <br/>

                          <Grid
                              templateColumns={{ sm: "1fr", lg: "1.3fr 1.7fr", xl: "repeat(4, 1fr)" }}
                              gap="24px"
                              mb={{ lg: "26px" }}
                          >
                              <Box mb={{ sm: "26px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{sm: "100%", md: "100%", lg: "300px"}}
                                      h="50px"
                                      mx={{sm: "auto", md: "0px"}}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/proposal/fire monitoring camera solution proposal_v2.1.pdf" download>
                                          {t('support:fireMonitoringProposal')}
                                      </a>
                                  </Button>
                              </Box>

                          </Grid>
                      </Flex>
                  </Flex>

              </CardBody>
          </Card>

          <Card p="16px">
              <CardBody>
                  <Flex direction="column" w="100%">
                      <Flex direction="column" mt="24px" mb="36px" alignSelf="flex-start">
                          <Text fontSize="lg" color={textColor} fontWeight="bold" mb="6px">
                              {t('support:catalog.title')}
                          </Text>
                          <Text fontSize="md" fontWeight="medium" color="gray.400">
                              <Text
                                  as="span"
                                  color={"green.400"}
                                  fontWeight="bold"
                              >
                              </Text>{" "}
                                {t('support:catalog.description')}
                          </Text>
                          <br/>
                          <Grid
                              templateColumns={{ sm: "1fr", lg: "1.3fr 1.7fr", xl: "repeat(4, 1fr)" }}
                              gap="24px"
                              mb={{ lg: "26px" }}
                          >
                              <Box mb={{ sm: "28px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/catalog/tgcam_bullet series product_rev1.0.pdf" download>
                                          {t('support:catalogItems.bullet')}
                                      </a>
                                  </Button>
                              </Box>
                              <Box mb={{ sm: "28px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/catalog/tgcam speed dome series product rev1.0.pdf" download>
                                          {t('support:catalogItems.speedDome')}
                                      </a>
                                  </Button>
                              </Box>
                              <Box mb={{ sm: "28px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/catalog/tgcam_dome series product_rev1.0.pdf" download>
                                          {t('support:catalogItems.dome')}
                                      </a>
                                  </Button>
                              </Box>
                              <Box mb={{ sm: "28px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/catalog/tgcam_ptz series product_rev3.0.pdf" download>
                                          {t('support:catalogItems.ptz')}
                                      </a>
                                  </Button>
                              </Box>
                              <Box mb={{ sm: "28px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/catalog/tgcam_housing series product_rev1.0.pdf" download>
                                          {t('support:catalogItems.housing')}
                                      </a>
                                  </Button>
                              </Box>
                              <Box mb={{ sm: "28px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/catalog/tgcam_ai_dual_light_series product_rev5.0.pdf" download>
                                          {t('support:catalogItems.aiDualLight')}
                                      </a>
                                  </Button>
                              </Box>
                                                            <Box mb={{ sm: "28px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/catalog/tgcam_fire_alarm_products.pdf" download>
                                          {t('support:catalogItems.fireAlarm')}
                                      </a>
                                  </Button>
                              </Box>
                          </Grid>

                      </Flex>
                  </Flex>

              </CardBody>
          </Card>

          <Card p="16px">
              <CardBody>
                  <Flex direction="column" w="100%">

                      <Flex direction="column" mt="24px" mb="36px" alignSelf="flex-start">
                          <Text fontSize="lg" color={textColor} fontWeight="bold" mb="6px">
                                {t('support:software.title')}
                          </Text>
                          <Text fontSize="md" fontWeight="medium" color="gray.400">
                              <Text
                                  as="span"
                                  color={"green.400"}
                                  fontWeight="bold"
                              >
                              </Text>{" "}
                              {t('support:software.description')}
                          </Text>
                          <br/>

                          <Grid
                              templateColumns={{ sm: "1fr", lg: "1.3fr 1.7fr", xl: "repeat(4, 1fr)" }}
                              gap="24px"
                              mb={{ lg: "26px" }}
                          >
                              <Box mb={{ sm: "26px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{sm: "100%", md: "100%", lg: "300px"}}
                                      h="50px"
                                      mx={{sm: "auto", md: "0px"}}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/software/setup_ipmanager_v2.1.0.8.exe.xz" download>
                                          {t('support:ipManager')}
                                      </a>
                                  </Button>
                              </Box>

                          </Grid>
                      </Flex>
                  </Flex>

              </CardBody>
          </Card>

          <Card p="16px">
              <CardBody>
                  <Flex direction="column" w="100%">

                      <Flex direction="column" mt="24px" mb="36px" alignSelf="flex-start">
                          <Text fontSize="lg" color={textColor} fontWeight="bold" mb="6px">
                                {t('support:manual.title')}
                          </Text>
                          <Text fontSize="md" fontWeight="medium" color="gray.400">
                              <Text
                                  as="span"
                                  color={"green.400"}
                                  fontWeight="bold"
                              >
                              </Text>{" "}
                                {t('support:manual.description')}
                          </Text>
                            <br/>

                          <Grid
                              templateColumns={{ sm: "1fr", lg: "1.3fr 1.7fr", xl: "repeat(4, 1fr)" }}
                              gap="24px"
                              mb={{ lg: "26px" }}
                          >
                              <Box mb={{ sm: "26px", lg: "0px" }}>
                                  <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{sm: "100%", md: "100%", lg: "300px"}}
                                      h="50px"
                                      mx={{sm: "auto", md: "0px"}}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/manual/mini ptz bullet_web-based korea instructions_2025y.pdf"
                                         download>
                                          {t('support:manualItems.miniPtz')}
                                      </a>
                                  </Button>
                              </Box>
                              <Box mb={{sm: "26px", lg: "0px"}}>
                              <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/manual/mini ptz vandal dome_ web-based korea instructions _2025y.pdf" download>
                                          {t('support:manualItems.miniPtzVandalDome')}
                                      </a>
                                  </Button>
                              </Box>
                              <Box mb={{sm: "26px", lg: "0px"}}>
                              <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/manual/ptz positioning _ web-based korea instructions - 2025y.pdf" download>
                                          {t('support:manualItems.ptzPositioning')}
                                      </a>
                                  </Button>
                              </Box>
                                <Box mb={{sm: "26px", lg: "0px"}}>
                              <Button
                                      variant="no-hover"
                                      bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
                                      w={{ sm: "100%", md: "100%", lg: "300px" }}
                                      h="50px"
                                      mx={{ sm: "auto", md: "0px" }}
                                      color="#fff"
                                      fontSize="xs"
                                      fontWeight="bold"
                                  >
                                      <a href="/manual/fire_monitoring_manual.zip" download>
                                          {t('support:manualItems.fireMonitoring')}
                                      </a>
                                  </Button>
                              </Box>
                          </Grid>

                      </Flex>
                  </Flex>


              </CardBody>
          </Card>
      </Grid>

    </Flex>
  );
}
